import { compiledAppBuild, tabAppBuild } from './appBuild';
import type { MutationAuthorMetadata } from './mutations';

export const webBundleId = 'alfrec.web';
export const webChannel = 'web' as const;
export const webReadContractVersion = 1 as const;

export const tabMutationMetadata = (): MutationAuthorMetadata => ({
  appBuild: tabAppBuild(),
  channel: webChannel,
  readContractVersion: webReadContractVersion,
});

export const engineMutationMetadata = (): MutationAuthorMetadata => ({
  appBuild: compiledAppBuild,
  channel: webChannel,
  readContractVersion: webReadContractVersion,
});

export const clientMetadataHeaders = (
  appBuild = tabAppBuild(),
): Record<string, string> => ({
  'X-App-Build': String(appBuild),
  'X-App-Bundle-ID': webBundleId,
  'X-App-Channel': webChannel,
  'X-Read-Contract-Version': String(webReadContractVersion),
});
